export type TipoAtividade = 'login' | 'transacao' | 'resgate' | 'saque' | 'alteracao_perfil' | 'troca_senha';

export interface AtividadeUsuario {
  id: string;
  usuarioEmail: string;
  usuarioId: string;
  tipo: TipoAtividade;
  descricao: string;
  data: string;
  ip?: string;
  dispositivo?: string;
  detalhes?: Record<string, string | number | boolean | undefined>;
  valor?: number;
  pontos?: number;
  status?: 'sucesso' | 'falha' | 'pendente' | 'cancelado';
  campanhaId?: string;
  campanhaNome?: string;
}

export const atividadesUsuario: AtividadeUsuario[] = [
  // ─── João Pedro Silva (joao.silva@email.com) — CAMP-001 ───
  {
    id: 'ACT-001-001',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T08:15:00Z',
    ip: '189.45.123.10',
    dispositivo: 'Chrome / Windows',
    status: 'sucesso',
  },
  {
    id: 'ACT-001-002',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-05-05T14:30:00Z',
    pontos: 3200,
    valor: 1280.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { destino: 'Banco do Brasil ****1234', tipo: 'PIX' },
  },
  {
    id: 'ACT-001-003',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'transacao',
    descricao: 'Pontuação por venda realizada',
    data: '2026-05-03T10:00:00Z',
    pontos: 1500,
    valor: 7500.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { idTransacao: 'TX-20260503-001', produto: 'Smartphone Galaxy S25' },
  },
  {
    id: 'ACT-001-004',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-02T18:45:00Z',
    ip: '189.45.123.10',
    dispositivo: 'Safari / iPhone',
    status: 'sucesso',
  },
  {
    id: 'ACT-001-005',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'troca_senha',
    descricao: 'Senha alterada pelo usuário',
    data: '2026-04-28T09:20:00Z',
    ip: '189.45.123.10',
    status: 'sucesso',
  },
  {
    id: 'ACT-001-006',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-20T11:00:00Z',
    pontos: 2500,
    valor: 1000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { destino: 'Banco do Brasil ****1234', tipo: 'PIX' },
  },
  {
    id: 'ACT-001-007',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'transacao',
    descricao: 'Pontuação por meta atingida',
    data: '2026-04-15T16:00:00Z',
    pontos: 2200,
    valor: 15000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { idTransacao: 'TX-20260415-002', produto: 'Pacote Corporativo' },
  },
  {
    id: 'ACT-001-008',
    usuarioEmail: 'joao.silva@email.com',
    usuarioId: 'PART-001',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-04-10T07:30:00Z',
    ip: '201.33.55.88',
    dispositivo: 'Firefox / Linux',
    status: 'sucesso',
  },

  // ─── Beatriz Santos (bia.santos@email.com) — CAMP-001, CAMP-002, CAMP-004 ───
  {
    id: 'ACT-002-001',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T09:00:00Z',
    ip: '177.88.44.22',
    dispositivo: 'Chrome / macOS',
    status: 'sucesso',
  },
  {
    id: 'ACT-002-002',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-05-07T13:15:00Z',
    pontos: 5000,
    valor: 2000.00,
    status: 'pendente',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { destino: 'Itaú ****5678', tipo: 'PIX', aguardandoAprovacao: true },
  },
  {
    id: 'ACT-002-003',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'transacao',
    descricao: 'Pontuação por venda realizada',
    data: '2026-05-06T11:30:00Z',
    pontos: 3000,
    valor: 12500.00,
    status: 'sucesso',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { idTransacao: 'TX-20260506-003', produto: 'Serviço Premium' },
  },
  {
    id: 'ACT-002-004',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'alteracao_perfil',
    descricao: 'Dados bancários atualizados',
    data: '2026-05-01T10:45:00Z',
    ip: '177.88.44.22',
    status: 'sucesso',
    detalhes: { campo: 'dados_bancarios' },
  },
  {
    id: 'ACT-002-005',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'login',
    descricao: 'Tentativa de login falhou — senha incorreta',
    data: '2026-04-29T20:10:00Z',
    ip: '177.88.44.22',
    dispositivo: 'Chrome / Android',
    status: 'falha',
  },
  {
    id: 'ACT-002-006',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'resgate',
    descricao: 'Resgate de pontos cancelado pelo usuário',
    data: '2026-04-25T16:00:00Z',
    pontos: 1500,
    valor: 600.00,
    status: 'cancelado',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { motivo: 'Cancelado pelo usuário' },
  },
  {
    id: 'ACT-002-007',
    usuarioEmail: 'bia.santos@email.com',
    usuarioId: 'PART-002',
    tipo: 'transacao',
    descricao: 'Pontuação por treinamento concluído',
    data: '2026-04-10T14:00:00Z',
    pontos: 600,
    valor: 0,
    status: 'sucesso',
    campanhaId: 'CAMP-004',
    campanhaNome: 'Capacitação Q2',
    detalhes: { idTransacao: 'TX-20260410-007', treinamento: 'Gestão de Projetos' },
  },

  // ─── Roberto Dias (roberto.dias@email.com) — CAMP-001, CAMP-002 ───
  {
    id: 'ACT-003-001',
    usuarioEmail: 'roberto.dias@email.com',
    usuarioId: 'PART-003',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-09T07:00:00Z',
    ip: '200.189.67.12',
    dispositivo: 'Chrome / Windows',
    status: 'sucesso',
  },
  {
    id: 'ACT-003-002',
    usuarioEmail: 'roberto.dias@email.com',
    usuarioId: 'PART-003',
    tipo: 'transacao',
    descricao: 'Pontuação por venda realizada',
    data: '2026-05-03T09:00:00Z',
    pontos: 800,
    valor: 4500.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { idTransacao: 'TX-20260503-004', produto: 'Tablet Android' },
  },
  {
    id: 'ACT-003-003',
    usuarioEmail: 'roberto.dias@email.com',
    usuarioId: 'PART-003',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-28T14:00:00Z',
    pontos: 1200,
    valor: 480.00,
    status: 'sucesso',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { destino: 'Nubank ****9012', tipo: 'PIX' },
  },
  {
    id: 'ACT-003-004',
    usuarioEmail: 'roberto.dias@email.com',
    usuarioId: 'PART-003',
    tipo: 'troca_senha',
    descricao: 'Senha alterada pelo usuário',
    data: '2026-04-15T09:30:00Z',
    ip: '200.189.67.12',
    status: 'sucesso',
  },
  {
    id: 'ACT-003-005',
    usuarioEmail: 'roberto.dias@email.com',
    usuarioId: 'PART-003',
    tipo: 'transacao',
    descricao: 'Pontuação por meta atingida',
    data: '2026-04-01T12:00:00Z',
    pontos: 500,
    valor: 3000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { idTransacao: 'TX-20260401-005' },
  },

  // ─── Luciana Almeida (luciana@empresaexemplo.com.br) — CAMP-001 ───
  {
    id: 'ACT-004-001',
    usuarioEmail: 'luciana@empresaexemplo.com.br',
    usuarioId: 'EMP-004',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T10:30:00Z',
    ip: '192.168.1.100',
    dispositivo: 'Safari / iPhone',
    status: 'sucesso',
  },
  {
    id: 'ACT-004-002',
    usuarioEmail: 'luciana@empresaexemplo.com.br',
    usuarioId: 'EMP-004',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-28T11:00:00Z',
    pontos: 2800,
    valor: 1120.00,
    status: 'sucesso',
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    detalhes: { destino: 'Bradesco ****3456', tipo: 'PIX' },
  },
  {
    id: 'ACT-004-003',
    usuarioEmail: 'luciana@empresaexemplo.com.br',
    usuarioId: 'EMP-004',
    tipo: 'alteracao_perfil',
    descricao: 'Endereço atualizado',
    data: '2026-04-20T15:30:00Z',
    ip: '192.168.1.100',
    status: 'sucesso',
    detalhes: { campo: 'endereco' },
  },
  {
    id: 'ACT-004-004',
    usuarioEmail: 'luciana@empresaexemplo.com.br',
    usuarioId: 'EMP-004',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-04-05T08:00:00Z',
    ip: '189.78.45.33',
    dispositivo: 'Chrome / Windows',
    status: 'sucesso',
  },

  // ─── Ricardo Ferreira (ricardo@inovacaodigital.com.br) — CAMP-003, CAMP-005 ───
  {
    id: 'ACT-005-001',
    usuarioEmail: 'ricardo@inovacaodigital.com.br',
    usuarioId: 'EMP-001',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T07:45:00Z',
    ip: '201.45.77.33',
    dispositivo: 'Chrome / Android',
    status: 'sucesso',
  },
  {
    id: 'ACT-005-002',
    usuarioEmail: 'ricardo@inovacaodigital.com.br',
    usuarioId: 'EMP-001',
    tipo: 'transacao',
    descricao: 'Pontuação por cliente captado',
    data: '2026-05-08T10:00:00Z',
    pontos: 600,
    valor: 8000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-003',
    campanhaNome: 'Captação de Clientes',
    detalhes: { idTransacao: 'TX-20260508-006', cliente: 'Empresa ABC Ltda' },
  },
  {
    id: 'ACT-005-003',
    usuarioEmail: 'ricardo@inovacaodigital.com.br',
    usuarioId: 'EMP-001',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-15T13:00:00Z',
    pontos: 900,
    valor: 360.00,
    status: 'sucesso',
    campanhaId: 'CAMP-003',
    campanhaNome: 'Captação de Clientes',
    detalhes: { destino: 'Santander ****7890', tipo: 'PIX' },
  },
  {
    id: 'ACT-005-004',
    usuarioEmail: 'ricardo@inovacaodigital.com.br',
    usuarioId: 'EMP-001',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-04-01T09:00:00Z',
    ip: '201.45.77.33',
    dispositivo: 'Safari / iPhone',
    status: 'sucesso',
  },
  {
    id: 'ACT-005-005',
    usuarioEmail: 'ricardo@inovacaodigital.com.br',
    usuarioId: 'EMP-001',
    tipo: 'transacao',
    descricao: 'Pontuação por novo cadastro',
    data: '2026-03-20T11:00:00Z',
    pontos: 3500,
    valor: 15000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-005',
    campanhaNome: 'Engajamento Trimestral',
    detalhes: { idTransacao: 'TX-20260320-005' },
  },

  // ─── Fernanda Costa (fernanda@techbrasil.com.br) — CAMP-003 ───
  {
    id: 'ACT-006-001',
    usuarioEmail: 'fernanda@techbrasil.com.br',
    usuarioId: 'EMP-002',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T09:15:00Z',
    ip: '189.76.22.11',
    dispositivo: 'Chrome / Windows',
    status: 'sucesso',
  },
  {
    id: 'ACT-006-002',
    usuarioEmail: 'fernanda@techbrasil.com.br',
    usuarioId: 'EMP-002',
    tipo: 'transacao',
    descricao: 'Pontuação por cliente captado',
    data: '2026-05-06T14:00:00Z',
    pontos: 1500,
    valor: 12000.00,
    status: 'sucesso',
    campanhaId: 'CAMP-003',
    campanhaNome: 'Captação de Clientes',
    detalhes: { idTransacao: 'TX-20260506-007', cliente: 'Tech Solutions S.A.' },
  },
  {
    id: 'ACT-006-003',
    usuarioEmail: 'fernanda@techbrasil.com.br',
    usuarioId: 'EMP-002',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-05-02T16:30:00Z',
    pontos: 2300,
    valor: 920.00,
    status: 'sucesso',
    campanhaId: 'CAMP-003',
    campanhaNome: 'Captação de Clientes',
    detalhes: { destino: 'Inter ****2345', tipo: 'PIX' },
  },
  {
    id: 'ACT-006-004',
    usuarioEmail: 'fernanda@techbrasil.com.br',
    usuarioId: 'EMP-002',
    tipo: 'troca_senha',
    descricao: 'Senha alterada pelo usuário',
    data: '2026-04-30T08:00:00Z',
    ip: '189.76.22.11',
    status: 'sucesso',
  },
  {
    id: 'ACT-006-005',
    usuarioEmail: 'fernanda@techbrasil.com.br',
    usuarioId: 'EMP-002',
    tipo: 'login',
    descricao: 'Tentativa de login falhou — conta bloqueada',
    data: '2026-04-25T22:00:00Z',
    ip: '189.76.22.11',
    dispositivo: 'Chrome / Android',
    status: 'falha',
  },

  // ─── Paulo Henrique (paulo@sistemasintegrados.com.br) — CAMP-004 ───
  {
    id: 'ACT-007-001',
    usuarioEmail: 'paulo@sistemasintegrados.com.br',
    usuarioId: 'EMP-003',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-09T08:30:00Z',
    ip: '177.99.44.55',
    dispositivo: 'Firefox / macOS',
    status: 'sucesso',
  },
  {
    id: 'ACT-007-002',
    usuarioEmail: 'paulo@sistemasintegrados.com.br',
    usuarioId: 'EMP-003',
    tipo: 'transacao',
    descricao: 'Pontuação por treinamento concluído',
    data: '2026-05-05T11:00:00Z',
    pontos: 400,
    valor: 0,
    status: 'sucesso',
    campanhaId: 'CAMP-004',
    campanhaNome: 'Capacitação Q2',
    detalhes: { idTransacao: 'TX-20260505-008', treinamento: 'Gestão de Projetos Avançado' },
  },
  {
    id: 'ACT-007-003',
    usuarioEmail: 'paulo@sistemasintegrados.com.br',
    usuarioId: 'EMP-003',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-25T10:00:00Z',
    pontos: 400,
    valor: 160.00,
    status: 'sucesso',
    campanhaId: 'CAMP-004',
    campanhaNome: 'Capacitação Q2',
    detalhes: { destino: 'Caixa ****1111', tipo: 'PIX' },
  },

  // ─── Amanda Rocha (amanda@consultoratech.com.br) — CAMP-002 ───
  {
    id: 'ACT-008-001',
    usuarioEmail: 'amanda@consultoratech.com.br',
    usuarioId: 'EMP-005',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-05-10T06:00:00Z',
    ip: '201.11.22.33',
    dispositivo: 'Safari / iPhone',
    status: 'sucesso',
  },
  {
    id: 'ACT-008-002',
    usuarioEmail: 'amanda@consultoratech.com.br',
    usuarioId: 'EMP-005',
    tipo: 'transacao',
    descricao: 'Pontuação por venda realizada',
    data: '2026-05-07T15:00:00Z',
    pontos: 2100,
    valor: 10500.00,
    status: 'sucesso',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { idTransacao: 'TX-20260507-009', produto: 'Consultoria Tech' },
  },
  {
    id: 'ACT-008-003',
    usuarioEmail: 'amanda@consultoratech.com.br',
    usuarioId: 'EMP-005',
    tipo: 'saque',
    descricao: 'Saque para conta bancária',
    data: '2026-04-18T09:30:00Z',
    pontos: 1500,
    valor: 600.00,
    status: 'sucesso',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { destino: 'Itaú ****9999', tipo: 'TED' },
  },
  {
    id: 'ACT-008-004',
    usuarioEmail: 'amanda@consultoratech.com.br',
    usuarioId: 'EMP-005',
    tipo: 'resgate',
    descricao: 'Resgate de pontos para conta bancária',
    data: '2026-04-10T16:00:00Z',
    pontos: 1800,
    valor: 720.00,
    status: 'pendente',
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    detalhes: { destino: 'Itaú ****9999', tipo: 'PIX' },
  },
  {
    id: 'ACT-008-005',
    usuarioEmail: 'amanda@consultoratech.com.br',
    usuarioId: 'EMP-005',
    tipo: 'login',
    descricao: 'Login realizado com sucesso',
    data: '2026-04-01T07:00:00Z',
    ip: '201.11.22.33',
    dispositivo: 'Chrome / Windows',
    status: 'sucesso',
  },
];

export function getAtividadesPorEmail(email: string): AtividadeUsuario[] {
  return atividadesUsuario
    .filter((a) => a.usuarioEmail.toLowerCase() === email.toLowerCase())
    .sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime());
}

export function getAtividadesPorTipo(email: string, tipo: TipoAtividade): AtividadeUsuario[] {
  return getAtividadesPorEmail(email).filter((a) => a.tipo === tipo);
}

export function getResumoAtividades(email: string): {
  total: number;
  logins: number;
  transacoes: number;
  resgates: number;
  saques: number;
  pontosResgatados: number;
  pontosAcumulados: number;
  falhasLogin: number;
} {
  const atividades = getAtividadesPorEmail(email);
  return {
    total: atividades.length,
    logins: atividades.filter((a) => a.tipo === 'login').length,
    transacoes: atividades.filter((a) => a.tipo === 'transacao').length,
    resgates: atividades.filter((a) => a.tipo === 'resgate').length,
    saques: atividades.filter((a) => a.tipo === 'saque').length,
    pontosResgatados: atividades
      .filter((a) => (a.tipo === 'resgate' || a.tipo === 'saque') && a.status === 'sucesso')
      .reduce((acc, a) => acc + (a.pontos || 0), 0),
    pontosAcumulados: atividades
      .filter((a) => a.tipo === 'transacao' && a.status === 'sucesso')
      .reduce((acc, a) => acc + (a.pontos || 0), 0),
    falhasLogin: atividades.filter((a) => a.tipo === 'login' && a.status === 'falha').length,
  };
}

export function getIconAtividade(tipo: TipoAtividade): string {
  switch (tipo) {
    case 'login': return 'ri-login-box-line';
    case 'transacao': return 'ri-exchange-line';
    case 'resgate': return 'ri-wallet-3-line';
    case 'saque': return 'ri-money-cny-circle-line';
    case 'alteracao_perfil': return 'ri-user-settings-line';
    case 'troca_senha': return 'ri-key-2-line';
    default: return 'ri-question-line';
  }
}

export function getColorAtividade(tipo: TipoAtividade): string {
  switch (tipo) {
    case 'login': return 'text-blue-500';
    case 'transacao': return 'text-emerald-500';
    case 'resgate': return 'text-amber-500';
    case 'saque': return 'text-orange-500';
    case 'alteracao_perfil': return 'text-gray-500';
    case 'troca_senha': return 'text-red-500';
    default: return 'text-gray-400';
  }
}

export function getBgColorAtividade(tipo: TipoAtividade): string {
  switch (tipo) {
    case 'login': return 'bg-blue-50';
    case 'transacao': return 'bg-emerald-50';
    case 'resgate': return 'bg-amber-50';
    case 'saque': return 'bg-orange-50';
    case 'alteracao_perfil': return 'bg-gray-50';
    case 'troca_senha': return 'bg-red-50';
    default: return 'bg-gray-50';
  }
}

export function getLabelAtividade(tipo: TipoAtividade): string {
  switch (tipo) {
    case 'login': return 'Login';
    case 'transacao': return 'Transação';
    case 'resgate': return 'Resgate';
    case 'saque': return 'Saque';
    case 'alteracao_perfil': return 'Alteração de Perfil';
    case 'troca_senha': return 'Troca de Senha';
    default: return tipo;
  }
}

export function getStatusColorAtividade(status: string): string {
  switch (status) {
    case 'sucesso': return 'bg-emerald-50 text-emerald-600';
    case 'falha': return 'bg-red-50 text-red-600';
    case 'pendente': return 'bg-amber-50 text-amber-600';
    case 'cancelado': return 'bg-gray-50 text-gray-500';
    default: return 'bg-gray-50 text-gray-500';
  }
}